<template>
  <div class="timeline-container" v-if="timelineInfo.length > 0">
    <div class="timeline" v-if="timelineInfo.length > 0" :class="playlistData.location">
      <figure class="timeline-icon" v-tooltip.top-center="playlistData.location"><img :src="icon" alt="Stadium"/></figure>
      <div class="track-wrapper" ref="timeline">
        <div class="timeline-track rounded">
          <div class="item-wrapper" 
            v-for="item in timelineInfo" 
            :key="item.id" 
            :style="{left: item.timeSlot + '%'}"
            >
            <div class="item" 
              v-tooltip.top-center="item.name"
              :class="{done: getPlaylistStatus(scenarioId, item.id), active: item.id === playlistId && ! getPlaylistStatus(scenarioId, item.id)}"
              @click="navigatoToPlaylist(item.id)">
              <i class="material-icons done" v-if="getPlaylistStatus(scenarioId, item.id)">check_circle</i>
              <i class="material-icons" v-else-if="item.id === playlistId">timer</i>
            </div>
            <ul v-if="item.id === playlistId && item.items.length > 0" class="decisions">
              <li v-for="(d, index) in item.items" 
                :key="index" class="decision"
                :class="{done: hasResponse(scenarioId, item.id, d.id)}">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "TimelineContainer",
  mixins: [scenarioMixin],
  data () {
    return {
    }
  },
  mounted () {
    let tl = this.$refs.timeline

    if ( tl.querySelector('.active') ) {
      let offset = tl.querySelector('.active').offsetLeft
      tl.scroll(offset - 38, 0)
    }
  },
  methods: {
    navigatoToPlaylist (pid) {
      this.$router.push({ path: '/trainee/scenario/'+this.scenarioId+'/playlist/'+ pid })
    },
    hasResponse (sid, pid, id) {
      return this.$store.getters["traineeStatusModule/hasResponseDeep"]({id: id, sid: sid, pid: pid});
    },
    getPlaylistStatus (sid, pid) {
      return this.$store.getters["traineeStatusModule/getPlaylistStatus"]({sid: sid, pid: pid});
    }
  },
  computed: {
    timelineInfo () {
      return this.$store.getters["scenarioModule/getTimelineInfo"](this.scenarioId)
    },
    stadiumTimelines () {
      return this.timelineInfo.filter(pl => {
        return pl.location == "stadium"
      })
    },
    cityTimelines () {
      return this.timelineInfo.filter(pl => {
        return pl.location == "city"
      })
    },
    countryTimelines () {
      return this.timelineInfo.filter(pl => {
        return pl.location == "country"
      })
    },
    icon () {
      return require(`@/assets/${this.playlistData.location}.svg`)
    }
  }
}
</script>

<style scoped lang="scss">
.timeline-container{
  // grid-area: timelines;
  max-width: var(--container-width);
  margin: 0 auto;
  width: 100%;

  @media all and (max-width: 767px) {
    // padding: 0 15px 0 66px;
    // padding: 0 0 0 52px;
  }
}

.timeline {
  position: relative;
  width: 100%;
  height: 39px;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  // border: 2px solid transparent;

  &.stadium {
    .timeline-track {
      border-color: #3d3dde;
    }
    .item {
      border-color: #3d3dde
    }
    .item.active {
      background-color: #3d3dde;
    }
  }
  &.city {
    .timeline-track {
      border-color: #e1651d;
    }
    .item {
      border-color: #e1651d
    }
    .item.active {
      background-color: #e1651d;
    }
  }
  &.country {
    .timeline-track {
      border-color: #179f83;
    }
    .item {
      border-color: #179f83
    }
    .item.active {
      background-color: #179f83;
    }
  }
  .timeline-icon {
    position: relative;
    max-width: 54px;
    min-width: 54px;
    height: 39px;
    margin: 0;

    img {
      height: 39px;
      width: auto;
    }
  }

  .track-wrapper {
    // overflow: hidden;
    overflow-x: auto;
    flex: 1;
    height: 100%;
    max-width: calc(100% - 54px);
    display: flex;
    align-items: center;

    background:
				linear-gradient(90deg, white 0%, rgba(255,255,255,0)),
				linear-gradient(-90deg, white 0%, rgba(255,255,255,0)) 100% 0,
				radial-gradient(
					farthest-side at 0% 10%,
					rgba(0,0,0,.2),
					rgba(0,0,0,0)
				),
				radial-gradient(
					farthest-side at 100% 10%,
					rgba(0,0,0,.2),
					rgba(0,0,0,0)
				) 100% 0%;
			background-repeat: no-repeat;
			background-color: #fff;
			background-size: 100px 137px, 100px 137px, 14px 137px, 14px 137px;
			background-attachment: local, local, scroll, scroll;
  }

  .timeline-track {
    position: relative;
    flex: 1;
    height: 27px;
    display: flex;
    justify-content: space-evenly;
     align-items: center;
    overflow: visible;
    border: 2px solid transparent;
    // margin-right: 20px;
    // border-left: 0;
    // border-top-left-radius: 0;
    // border-bottom-left-radius: 0;


  }

  .item-wrapper {
    display: flex;
    align-items: center;
    padding: 0 15px;
  }

  .item {
    // position: absolute;
    border: 2px solid transparent;
    height: 13px;
    width: 13px;
    border-radius: 50%;
  
    cursor: pointer;
    transition: opacity .3s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;

    &:hover {
      opacity: 0.8;
    }

    &.active {
      opacity: 1;
      color: #fff;
      // height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      i {
        font-size: 10px;
      }
    }

    &.done {
      background-color: transparent;
      border-color: transparent;
      color: #21D64C;
      height: 17px;
      left: -3px;
      position: relative;
      top: -2px;

      i {
        font-size: 17px;
      }
    }
  }
  .decisions {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0;
    list-style: none;

    &:before {
      content: " ";
      width: 100%;
      height: 1px;
      position: absolute;
      left: 0;
      top: 48%;
      background-color: #3d3dde;
    }
  }
  .decision {
    width: 7px;
    height: 7px;
    background-color: #3d3dde;
    border-radius: 50%;
    margin-left: 10px;
    z-index: 10;

    &.done {
      background-color: #21D64C;
    }

  }
}
</style>